export function getAgentBaseUrl(aiWebhookUrl) {
  if (!aiWebhookUrl) return "";
  const endpoint = aiWebhookUrl.trim();
  if (!endpoint) return "";

  const sameOrigin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "";

  try {
    const url = endpoint.startsWith("/")
      ? new URL(endpoint, sameOrigin || undefined)
      : new URL(endpoint);
    return `${url.protocol}//${url.host}`;
  } catch {
    return endpoint.replace(/\/agent\/v1\/assistant\/chat.*$/, "");
  }
}

export async function fetchConversations({ agentBaseUrl, username, service }) {
  const params = new URLSearchParams({ username });
  if (service) params.set("service", service);
  const res = await fetch(`${agentBaseUrl}/agent/v1/chats?${params}`);
  if (!res.ok) throw new Error(`Error al cargar historial: ${res.status}`);
  return res.json();
}

export async function fetchConversation({ agentBaseUrl, conversationId, username }) {
  const params = new URLSearchParams({ username });
  const res = await fetch(`${agentBaseUrl}/agent/v1/chats/${conversationId}?${params}`);
  if (!res.ok) throw new Error(`Error al cargar conversación: ${res.status}`);
  return res.json();
}

export async function deleteConversation({ agentBaseUrl, conversationId, username }) {
  const params = new URLSearchParams({ username });
  const res = await fetch(`${agentBaseUrl}/agent/v1/chats/${conversationId}?${params}`, {
    method: "DELETE",
  });
  if (!res.ok && res.status !== 404) {
    throw new Error(`Error al eliminar conversación: ${res.status}`);
  }
  return true;
}

export async function fetchDashboardCharts({
  agentBaseUrl,
  username,
  service = "scapp",
  view = "insight",
}) {
  const params = new URLSearchParams({ username, service, view });
  const res = await fetch(`${agentBaseUrl}/agent/v1/dashboard-charts?${params}`);
  if (!res.ok) throw new Error(`Error al cargar gráficos: ${res.status}`);
  return res.json();
}

export async function createDashboardChart({
  agentBaseUrl,
  username,
  service = "scapp",
  view = "insight",
  title,
  chartSpec,
  position = 0,
}) {
  const res = await fetch(`${agentBaseUrl}/agent/v1/dashboard-charts`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, service, view, title, chartSpec, position }),
  });
  if (!res.ok) throw new Error(`Error al guardar gráfico: ${res.status}`);
  return res.json();
}

export async function updateDashboardChart({ agentBaseUrl, chartId, username, updates }) {
  const res = await fetch(`${agentBaseUrl}/agent/v1/dashboard-charts/${chartId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, ...updates }),
  });
  if (!res.ok) throw new Error(`Error al actualizar gráfico: ${res.status}`);
  return res.json();
}

export async function deleteDashboardChart({ agentBaseUrl, chartId, username }) {
  const params = new URLSearchParams({ username });
  const res = await fetch(`${agentBaseUrl}/agent/v1/dashboard-charts/${chartId}?${params}`, {
    method: "DELETE",
  });
  if (!res.ok && res.status !== 404) throw new Error(`Error al eliminar gráfico: ${res.status}`);
  return true;
}
